import React, { useMemo, useState } from "react";
import { Pressable, Text, View } from "react-native";

import { AI_EXHIBIT_COLORS as C } from "../aiExhibitTheme";
import { AI_EXHIBIT_CURRENT_STATUS } from "../content/aiExhibitCurrentStatus";
import { getAIExhibitBatch5Copy } from "../content/aiExhibitBatch5Content";

export default function SourcesScreen({ language = "en" }) {
  const t = getAIExhibitBatch5Copy(language).sources;
  const [sourceId, setSourceId] = useState(t.cards[0].id);

  const source = useMemo(
    () => t.cards.find((item) => item.id === sourceId) || t.cards[0],
    [sourceId, t.cards]
  );

  return (
    <View style={{ padding: 28 }}>
      <Text style={{ color: C.accent, fontSize: 13, fontWeight: "900", letterSpacing: 1.2 }}>
        {t.eyebrow}
      </Text>

      <Text style={{ color: C.text, fontSize: 44, lineHeight: 50, fontWeight: "900", marginTop: 8 }}>
        {t.title}
      </Text>

      <Text style={{ color: C.muted, fontSize: 18, lineHeight: 27, marginTop: 8, maxWidth: 980 }}>
        {t.subtitle}
      </Text>

      <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 10, marginTop: 24 }}>
        {t.cards.map((item) => {
          const active = item.id === sourceId;

          return (
            <Pressable
              key={item.id}
              onPress={() => setSourceId(item.id)}
              style={({ pressed }) => ({
                width: "23.7%",
                minWidth: 235,
                flexGrow: 1,
                minHeight: 120,
                padding: 16,
                borderRadius: 15,
                borderWidth: active ? 2 : 1,
                borderColor: active ? C.accent : C.border,
                backgroundColor: active || pressed ? C.accentSoft : C.surfaceRaised,
              })}
            >
              <Text style={{ color: C.text, fontSize: 16, lineHeight: 22, fontWeight: "900" }}>
                {item.title}
              </Text>
              <Text style={{ color: C.muted, fontSize: 12, lineHeight: 18, marginTop: 6 }}>
                {item.organization}
              </Text>
            </Pressable>
          );
        })}
      </View>

      <View style={{ marginTop: 18, padding: 22, borderRadius: 18, borderWidth: 1, borderColor: C.accent, backgroundColor: C.surfaceRaised }}>
        <Text style={{ color: C.text, fontSize: 24, lineHeight: 31, fontWeight: "900" }}>
          {source.title}
        </Text>
        <Text style={{ color: C.accent, fontSize: 14, fontWeight: "800", marginTop: 5 }}>
          {source.organization}
        </Text>

        <Text style={{ color: C.text, fontSize: 16, lineHeight: 25, marginTop: 15 }}>
          {source.usedFor}
        </Text>

        <View style={{ marginTop: 14, padding: 13, borderRadius: 13, backgroundColor: C.surface }}>
          <Text selectable style={{ color: C.muted, fontSize: 13, lineHeight: 20 }}>
            {source.url}
          </Text>
        </View>
      </View>

      <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 14, marginTop: 18 }}>
        <View style={{ flex: 1, minWidth: 350, padding: 18, borderRadius: 16, borderWidth: 1, borderColor: C.border, backgroundColor: C.surfaceRaised }}>
          <Text style={{ color: C.text, fontSize: 19, fontWeight: "900" }}>
            {t.metadataTitle}
          </Text>
          <Text style={{ color: C.muted, fontSize: 15, lineHeight: 23, marginTop: 8 }}>
            {t.metadata}
          </Text>
        </View>

        <View style={{ flex: 1, minWidth: 350, padding: 18, borderRadius: 16, borderWidth: 1, borderColor: C.border, backgroundColor: C.surfaceRaised }}>
          <Text style={{ color: C.text, fontSize: 17, lineHeight: 26, fontWeight: "800" }}>
            {t.reviewed}
          </Text>
          <Text style={{ color: C.accent, fontSize: 14, fontWeight: "900", marginTop: 9 }}>
            {language === "es" ? "Última revisión:" : "Current review date:"}{" "}
            {AI_EXHIBIT_CURRENT_STATUS.lastReviewed}
          </Text>
        </View>
      </View>

      <View style={{ marginTop: 16, padding: 17, borderRadius: 15, borderLeftWidth: 5, borderWidth: 1, borderColor: C.border, borderLeftColor: C.warning, backgroundColor: C.accentSoft }}>
        <Text style={{ color: C.text, fontSize: 15, lineHeight: 23 }}>
          {t.linkNote}
        </Text>
      </View>
    </View>
  );
}
